import { Grid } from '@mui/material';
import { RoutalLoader, VSpacer } from '@nx-smartmonkey/ui';
import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import * as routes from '../../../constants/Routing';
import { useRetrieveOrganizationUserInvitation } from '../../../hooks/organization/useRetrieveOrganizationUserInvitation';
import { useIsLogged } from '../../../hooks/session/useIsLogged';
import Text from '../../../react-components/Text';
import { AuthBody, AuthBodyFooter } from '../Auth.styled';
import { InvitationForm } from './InvitationForm';

export const Invitation = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const { isLogged } = useIsLogged();

  const {
    success: fetchInvitationSuccess,
    error: fetchInvitationError,
    data: invitationData,
    run: getOrganizationInvitation,
  } = useRetrieveOrganizationUserInvitation({ token: token! });

  useEffect(() => {
    if (isLogged) {
      navigate(routes.PRIVATE_HIGHWAY);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLogged]);

  useEffect(() => {
    if (fetchInvitationError) {
      navigate(`${routes.AUTH.LOGIN}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchInvitationError]);

  useEffect(() => {
    if (token && !invitationData) {
      getOrganizationInvitation();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  return (
    <>
      {!fetchInvitationSuccess || !invitationData ? (
        <>
          <AuthBody container direction="column" justifyContent="center">
            <Grid container justifyContent="center">
              <RoutalLoader />
            </Grid>
          </AuthBody>

          <Grid item>
            <VSpacer large />
            <VSpacer large />
          </Grid>
        </>
      ) : (
        <>
          <InvitationForm invitationData={invitationData} />

          <Grid item>
            <VSpacer medium />
          </Grid>
        </>
      )}

      <AuthBodyFooter item container justifyContent="space-between">
        <Grid item>
          <Text
            isBold
            style={{
              fontSize: `12px`,
            }}
            variant="button"
            intlId="auth.login"
            onClick={() => navigate(routes.AUTH.LOGIN)}
          />
        </Grid>

        <Grid item>
          <Text
            isBold
            style={{
              fontSize: `12px`,
            }}
            variant="button"
            intlId="auth.forgotten_password"
            onClick={() => navigate(routes.AUTH.RESET_PASSWORD)}
          />
        </Grid>
      </AuthBodyFooter>
    </>
  );
};
